export const CursorMode = {
    DEFAULT: 'default',
    BRUSH: 'brush'
}